<template>
  <v-container fluid class="routercontainer ma-0 pa-0" align="center" justify="center">
    <!-- <t-background style="min-height: 1900px; "></t-background> -->
    <!-- <t-background noautoheight style="position: absolute; min-height: 5500px; top: -3600px; width: 1920px"></t-background> -->
    <v-row align="center" justify="center" class="my-0 py-0 px-2">
      <v-col cols="12" sm="8" md="6" lg="4" xl="4" class="my-0 py-0" align="center">
        <!-- <v-img contain width="auto" :max-width="500" height="auto" style="cursor: pointer" class="ma-0 pa-0" @click="openTremolSite()" :src="require('../../assets/img/tremollogo.png')"></v-img> -->

        <v-row aling="start" justify="space-around">
          <v-col cols="10" sm="10" md="8" lg="8" xl="8" align="center" style="z-index: 10; cursor: pointer">
            <v-list-item style="cursor: pointer" :style="`background-color: `" @click="openWebSite('https://ev.tremol.bg/')">
              <v-img :src="require('@/assets/EVp1.png')"></v-img>
              <span class="mа-0 pa-2" style="position: absolute; right: 10px; bottom: -7px; font-size: 10px">{{ "v. " + getAppVer() }}</span>
            </v-list-item>
          </v-col>
          <!-- <v-col cols="12" sm="12" md="5" lg="5" xl="5" align="center">
            <v-row align="center" justify="center" class="ma-0">
              <div @click="setLanguage('bg')" class="ma-1 pa-1" style="cursor: pointer; z-index: 99">
                <country-flag style="cursor: pointer; border: 1px solid black" country="bg" size="big" />
              </div>
              <div @click="setLanguage('ro')" class="ma-1 pa-1" style="cursor: pointer; z-index: 99">
                <country-flag style="cursor: pointer; border: 1px solid black" country="ro" size="big" />
              </div>
              <div @click="setLanguage('md')" class="ma-1 pa-1" style="cursor: pointer; z-index: 99">
                <country-flag style="cursor: pointer; border: 1px solid black" country="md" size="big" />
              </div>
            </v-row>
          </v-col> -->
        </v-row>
        <v-card class="elevation-24 mt-4" shaped>
          <v-card-text>
            <v-form ref="loginForm" v-model="valid" lazy-validation>
              <v-row align="center" justify="center" class="ma-2 mb-0 pa-0">
                <v-col cols="12" class="ma-0 pa-0">
                  <v-text-field
                    ref="refUser"
                    v-model="username"
                    name="username"
                    placeholder=" "
                    autocomplete="username"
                    label="Потребител"
                    prepend-icon="mdi-account"
                    @keyup.enter="login()"
                  />
                </v-col>
                <v-col cols="12" class="ma-0 pa-0">
                  <v-text-field
                    v-model="password"
                    id="password"
                    placeholder=" "
                    prepend-icon="mdi-lock"
                    name="password"
                    autocomplete="current-password"
                    :type="show1 ? 'text' : 'password'"
                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                    label="Парола"
                    @click:append="show1 = !show1"
                    @keydown="isCapsOn"
                    @keyup.enter="login()"
                  >
                    <CapsTooltip v-if="capsOn" slot:append-outer />
                  </v-text-field>
                </v-col>
              </v-row>

              <v-row class="ma-1 pa-0" justify="space-between">
                <v-col cols="12" class="my-0 py-0">
                  <v-btn :color="Colors.IconColor" class="white--text" block :disabled="!valid || wait_login_timeout" @click="login()" autofocus>Вход</v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
// import HTTPSender from "../js/HTTPSender";

import CapsTooltip from "@/components/helpers/CapsTooltip.vue";
import DataManager from "@/data/DataManager";
import { g_Dialog } from "@/main";
// import CountryFlag from "vue-country-flag";
import packageInfo from "../../package.json";
import HTTPSender from "@/js/HTTPSender";

export default {
  props: {
    propusername: String,
    proppassword: String,
    source: String,
  },
  components: {
    CapsTooltip,
    // CountryFlag,
  },
  data() {
    return {
      isVisible: true,
      capsOn: false,
      show1: false,
      valid: true,
      wait_login_timeout: false,
      wait_change_pass_timeout: false,
      username: this.propusername,
      password: this.proppassword,
    };
  },
  computed: {},
  methods: {
    getAppVer() {
      return packageInfo.version;
    },
    // setLanguage(lang) {// },
    isCapsOn(e) {
      this.capsOn = this.isCapsLockOn(e);
    },

    login() {
      if (!this.username || !this.password || this.username.length < 3 || this.password.length < 1) {
        g_Dialog.showError("Невалиден потребител или парола!");
        return;
      }
      this.wait_login_timeout = true;
      g_Dialog.show(g_Dialog.dialog_types.loader, null, { message: "Вход в системата..." }).then(() => {
        setTimeout(() => {
          DataManager.login(this.username, this.password, (resp) => {
            g_Dialog.close().then(() => {
              if (resp.message) {
                g_Dialog.showError("Грешка при влизане в системата!\n" + resp.message);
                this.username = "";
                this.password = "";
              } else {
                for (const [k, v] of Object.entries(DataManager.user.settings1)) {
                  this.IF[k] = v;
                }
                this.$router.push({ name: this.IF.StartPage ? this.IF.StartPage : "DashBoard" });
              }
              setTimeout(() => {
                this.wait_login_timeout = false;
              }, 3000);
            });
          });
        }, 123);
      });
    },
  },
  updated() {
    g_Dialog.close();
  },
  created() {
    // if (this.$route.query.lang) {
    //   this.setLang(this.$route.query.lang);
    // }
  },
  mounted() {
    this.isOnTestServer = false;
    this.isInDarkMode = false;
    document.onreadystatechange = () => {
      if (document.readyState == "complete") {
        this.$nextTick(() => {
          g_Dialog.close();
        });
        var ver = localStorage.getItem("PACKAGE_VERSION");
        if (packageInfo.version != ver) {
          localStorage.setItem("PACKAGE_VERSION", packageInfo.version);
          try {
            window.location.reload(true);
          } catch {
            var asd = window.location.href;
            window.location.href = asd;
          }
        }
      }
    };
    if (this.$route.query.error) {
      g_Dialog.showError(this.$route.query.error);
    }
    if (this.$route.query.r) {
      HTTPSender.SetBearer(this.$route.query.r);
      //TODO
      // DataManager.loadData(DataManager.DataType.user, (err) => {
      //   if (err.ErrorCode == ErrorMessage.ERROR_CODE_OK) {
      //     DataManager.loadData(DataManager.DataType.subscription_plans, () => {
      //       DataManager.loadData(DataManager.DataType.discounts, () => {
      //         DataManager.loadData(DataManager.DataType.messages, () => {
      //           this.$router.push({ path: "/" + TR.Locale + "/help" }).catch(() => {});
      //         });
      //       });
      //     });
      //   } else {
      //     this.dialogLoader.hide();
      //     this.dialogLoader.showError("Грешка! " + err.Message, { timeout: 5000, location: "center" });
      //   }
      // });
    }
    if (this.$route.query.ts == "1") {
      this.isOnTestServer = true;
    }
  },
};
</script>
